/**
 * @generated SignedSource<<7c5dd370f3b4a86d6c879c4fc54517de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AWSAccessRoleInput = {
  accountDiscovery?: string | null | undefined;
  primary?: string | null | undefined;
  readOnly?: string | null | undefined;
  remediationPolicy?: string | null | undefined;
};
export type SetAwsAccessRolesMutation$variables = {
  input: AWSAccessRoleInput;
};
export type SetAwsAccessRolesMutation$data = {
  readonly setAWSAccessRoles: {
    readonly accountDiscovery: {
      readonly arn: string | null | undefined;
      readonly error: string | null | undefined;
    } | null | undefined;
    readonly primary: {
      readonly arn: string | null | undefined;
      readonly error: string | null | undefined;
    } | null | undefined;
    readonly readOnly: {
      readonly arn: string | null | undefined;
      readonly error: string | null | undefined;
    } | null | undefined;
    readonly remediationPolicy: {
      readonly arn: string | null | undefined;
      readonly error: string | null | undefined;
    } | null | undefined;
  };
};
export type SetAwsAccessRolesMutation = {
  response: SetAwsAccessRolesMutation$data;
  variables: SetAwsAccessRolesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "arn",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "error",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetAWSAccessRolePayload",
    "kind": "LinkedField",
    "name": "setAWSAccessRoles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AWSRolePayload",
        "kind": "LinkedField",
        "name": "accountDiscovery",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AWSRolePayload",
        "kind": "LinkedField",
        "name": "primary",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AWSRolePayload",
        "kind": "LinkedField",
        "name": "readOnly",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AWSRolePayload",
        "kind": "LinkedField",
        "name": "remediationPolicy",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetAwsAccessRolesMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetAwsAccessRolesMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0d633fe0069833f6924a92f8707d189e",
    "id": null,
    "metadata": {},
    "name": "SetAwsAccessRolesMutation",
    "operationKind": "mutation",
    "text": "mutation SetAwsAccessRolesMutation(\n  $input: AWSAccessRoleInput!\n) {\n  setAWSAccessRoles(input: $input) {\n    accountDiscovery {\n      arn\n      error\n    }\n    primary {\n      arn\n      error\n    }\n    readOnly {\n      arn\n      error\n    }\n    remediationPolicy {\n      arn\n      error\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b75e26d95766434354a436bfaaccdd3";

export default node;
